<template>
    <div>
        <div class="top-box">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>角色管理</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="tab-list d_flex a_c ">
                <h2>角色列表</h2>
                <div class="item" @click="add"><i class="icon el-icon-circle-plus" type="primary"></i>新增加角色</div>
            </div>
        </div>
        <div class="page-content">
            <div class="table">
                <el-table :data="roleList" border style="width: 60%">
                    <el-table-column fixed prop="role_id" label="角色编号" width="150" align="center">
                    </el-table-column>
                    <el-table-column prop="role_name" label="角色名称" align="center">
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="updateClick(scope.row)">修改</el-button>
                            <el-button type="text" size="small" @click="deleteClick(scope.row)">删除</el-button>
                            <el-button type="text" size="small" @click="updatelimits(scope.row)">编辑权限</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-dialog
                    title="修改权限信息"
                    :visible.sync="updateRole"
                    width="30%"
                    :before-close="handleClose">
                <el-form ref="form" :model="roleData" label-width="80px">
                    <el-form-item label="角色id">
                        <el-input v-model="roleData.role_id" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="角色名称">
                        <el-input v-model="roleData.role_name"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="updateRole = false">取 消</el-button>
                    <el-button type="primary" @click="subRole">修改</el-button>

                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import { getRoleList,saveRole,delRole } from '../../api/role'
    export default {
        name: "authority",
        data(){
            return{
                roleList:[],
                updateRole:false,
                roleData:{
                    role_name:'',
                    role_id:''
                }
            }
        },
        mounted(){
            this.getRoleList();
        },
        methods:{
            getRoleList(){
                getRoleList().then(res=>{
                    if(res.code==1){
                        this.roleList=res.data;
                        console.log(this.roleList)
                    }
                })
            },
            updateClick(row){
                console.log(row);
                this.roleData=row;
                this.updateRole=true;

            },
            deleteClick(row){
                console.log(row)
                this.$confirm('此操作将永久删除该角色, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delRole({role_id:row.role_id}).then(res=>{
                       if(res.code==1){
                           this.$message({
                               type: 'success',
                               message: '删除成功!'
                           });
                           this.getRoleList();
                       }
                    })
                }).catch(() => {

                });
            },
            subRole(){
                if(!this.roleData.role_name){
                    this.$message({
                        type: 'warning',
                        message: '角色名称不能为空!'
                    });
                    return;
                }
                saveRole(this.roleData).then(res=>{
                    if(res.code==1){
                        this.$message({
                            type: 'success',
                            message: '修改成功!'
                        });
                        this.handleClose();
                    }
                })
            },
            handleClose(){
              this.updateRole=false;
              this.roleData={
                  role_name:'',
                  role_id:''
              };
            },
            updatelimits(){

            },
            add(){
                this.$router.push({path: '/authority/add'});
            },
        }
    }
</script>

<style lang="scss" scoped>
.page-content{
    padding: 20px;
    .table{
        padding: 20px;
        background-color: #fff;
        box-shadow: 0 4px 4px 0 #e1e5eb;
    }
}
</style>
